const REPVISITS_LOCATION_TYPE = {
  IN_PERSON: 'IN_PERSON',
  VIRTUAL: 'VIRTUAL',
  EITHER: 'EITHER',
};

export default REPVISITS_LOCATION_TYPE;
